<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-12-12 11:18:30
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-08 18:10:28
 * @FilePath: \seller.sviptrader.com\src\components\business\switchView\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="switch" v-if="isShowView">
		<el-dropdown @command="handleCommand" placement="bottom-end">
			<div class="yx-border flex-row-align-center view font-h6-regular yx-color-g-9 radius-16 cursor-pointer">
				<i class="i-eye-fill"></i>
				<span class="ml-4">{{ roleName }}</span>
				<i class="el-icon-arrow-down el-icon--right"></i>
			</div>
			<el-dropdown-menu slot="dropdown">
				<div class="yx-color-g-9 flex-row-align-center font-h4-medium title mt-6 mb-6">
					<span class="pl-12">切换查看数据视角</span>
					<explain content="切换数据视角仅影响页面展示数据范围" placement="right" class="ml-4"></explain>
				</div>
				<el-dropdown-item
					:icon="item.active ? item.iconActive : item.icon"
					:command="item.value"
					:class="['pt-4 pb-4 pl-24 pr-24', item.active ? 'active' : '']"
					v-for="(item, index) in dataViewList"
					:key="index"
					:disabled="item.active"
				>
					{{ item.label }}
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
	</div>
</template>
<script>
import Explain from '@/components/common/explain';
import { mapState } from 'vuex';
export default {
	components: {
		Explain,
	},
	computed: {
		...mapState(['vuex_dataViewList', 'vuex_dataViewId']),
		isShowView({ vuex_dataViewList }) {
			return vuex_dataViewList.length > 1;
		},
	},
	data() {
		return {
			roleName: '全部数据',
			dataViewList: [],
		};
	},
	created() {
		const { vuex_dataViewId } = this;
		this.roleName = vuex_dataViewId
			? this.vuex_dataViewList.find(item => item.value === +vuex_dataViewId)?.label?.replace('(本人数据)', '')
			: '全部数据';
		this.dataViewList = this.vuex_dataViewList.map(item => ({
			icon: item.icon,
			label: item.label,
			value: item.value,
			iconActive: item.iconActive,
			active: this.roleName === item.label,
		}));
	},
	methods: {
		handleCommand(e) {
			this.roleName = this.vuex_dataViewList.find(item => item.value === e)?.label?.replace('(本人数据)', '');
			this.dataViewList.forEach(item => {
				if (e === item.value) {
					item.active = true;
				} else {
					item.active = false;
				}
			});
			this.$emit('change', e);
		},
	},
};
</script>
<style lang="less" scoped>
.switch {
	.view {
		padding: 5px 12px;
		opacity: 0.9;
	}
}
.title {
	padding: 0 15px;
}
.active {
	background-color: #eef4ff;
	color: @color-primary;
}
</style>
<style lang="less">
.el-popper[x-placement='bottom-end'] .popper__arrow {
	left: unset !important;
	right: 20px !important;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
	color: @color-text-regular;
}
</style>
